import akiki from '../../assets/Brand Center/akkiki.png';
import americantourister from '../../assets/Brand Center/american.webp';
import arctic from '../../assets/Brand Center/arctic.jpg';
import axor from '../../assets/Brand Center/axor.png';
import baggit from '../../assets/Brand Center/baggit.webp';
import borosil from '../../assets/Brand Center/brosil.jpg';
import caprese from '../../assets/Brand Center/caprese.jpg';
import Cello from '../../assets/Brand Center/Cellobag.png';
import duckback from '../../assets/Brand Center/duckback.webp';
import gear from '../../assets/Brand Center/gear.jpg';
import kammillient from '../../assets/Brand Center/kammillient.png';
import laOpala from '../../assets/Brand Center/LaOpala.jpg';
import lavie from '../../assets/Brand Center/lavie.png';
import milton from '../../assets/Brand Center/Milton.jpg';
import Prestige from '../../assets/Brand Center/Prestige_Brands.png';
import safari from '../../assets/Brand Center/safari.jpg';
import skybags from '../../assets/Brand Center/skybags.png';
import steelbird from '../../assets/Brand Center/stellbirds.png';
import tbase from '../../assets/Brand Center/tbase.webp';
import tommy from '../../assets/Brand Center/tommyhill.jpg';
import vega from '../../assets/Brand Center/vegaa.jpg';
import vip from '../../assets/Brand Center/vip.png';
import wildcraft from '../../assets/Brand Center/wildcraft.png';
import windbreaker from '../../assets/Brand Center/windbreaker.jpg';
import Zell from '../../assets/Brand Center/Zell.png';
// import thermoware from '../../assets/Brand Center/the.png';

const brands = [
  {name: 'American Tourister', logo: americantourister},
  {name:'akiki', logo: akiki},
  {name: 'duckback', logo: duckback},
  {name: 'kammillient', logo: kammillient},
  {name: 'vega', logo: vega},
  {name: 'axor', logo: axor},
  {name: 'lavie', logo: lavie},
  {name: 'Zell', logo: Zell},
  {name: 'windbreaker', logo: windbreaker},
  {name: 'tbase', logo: tbase},
];

const brands2 = [
  {name: 'vip', logo:vip},
  {name: 'safari', logo:safari},
  {name: 'skybags', logo:skybags},
  {name: 'steelbird', logo:steelbird},
  {name: 'wildcraft', logo:wildcraft},
  {name: 'gear', logo:gear},
  {name: 'arctic', logo:arctic},
  {name: 'tommy', logo:tommy},
  {name: 'baggit', logo:baggit},
  {name: 'caprese', logo:caprese},
  {name: 'borosil', logo:borosil},
  {name: 'milton', logo:milton},
  {name: 'Cello', logo:Cello},
  {name: 'Prestige', logo:Prestige},
  {name: 'laOpala', logo:laOpala},

];

const BrandCenter = () => {
  return (
    <div className={'py-16 px-4 '}>
      {/* Text */}
      <div className={'text-center max-w-3xl mx-auto mb-12'}>
        <h3 className={'title'}>Brand Center</h3>
        <p className={'Subtitle mt-3'}>
          We collaborate with trusted brands to ensure performance, trust,
          durability, quality, and warranty-backed peace of mind.
        </p>
      </div>

      {/* Brand Logos */}
      <h1 className={'Subtitle text-center mb-0 '}>We are Authorized Distributers Of : </h1>
      <div className={'  max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-12 items-center'}>
        {brands.map((brand, index) => (
          <div
            key={index}
            className={'flex items-center justify-center'}
          >
            
            <img
              src={brand.logo}
              alt={brand.name}
              className={'h-30 object-contain'}
            />
          </div>
        ))}
      </div>

      <div className={'mt-16'}>
        <h1 className={' Subtitle text-center'}>Also Top Authorized Dealers for : </h1>
        <div className={'  max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-12 items-center'}>
          {brands2.map((brand, index) => (
            <div
              key={index}
              className={'flex items-center justify-center'}
            >
            
              <img
                src={brand.logo}
                alt={brand.name}
                className={'h-30 object-contain'}
              />
            </div>
          ))}
        </div>

        <div className={'text-center max-w-3xl mx-auto mb-12'}>
          <p className={'Subtitle mt-3'}>
         Any Items of the companies which
 were not mentioned above in the List.
 Will also be provided and available for
 our Customer
          </p>
        </div>

      </div>
    </div>
  );
};

export default BrandCenter;
